module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eGoVi"))).then(() => parcelRequire('ikE14'));